import {createSlice} from "@reduxjs/toolkit";
import { toIST, startOfDay, endOfDay} from '../../../../../util/dateutil';
import TableRenderers from 'react-pivottable/TableRenderers';
import Plot from 'react-plotly.js';
import createPlotlyRenderers from 'react-pivottable/PlotlyRenderers';
// create Plotly renderers via dependency injection
const PlotlyRenderers = createPlotlyRenderers(Plot);


const initialTripsState = {
  listLoading: false,
  loadingMessage: "Loading...",
  actionsLoading: false,
  totalCount: 0,
  tripForEdit: undefined,
  entities: null,
  drumRotationsEntities: null,
  drumRotationsTotalCount: null,
  lastError: null,
  settings: {
    filter: {
      status: "",
      searchText: "",
      from: startOfDay(toIST(new Date()).toISOString()), 
      to: endOfDay(toIST(new Date()).toISOString()),
    },   
    sortOrder: "desc", // asc||desc
    sortField: "trip_id",
    pageNumber: 1,
    pageSize: 20,
    env: "dev"
  },
  pivotSettings: {
    rows: ['transporter', 'start_date'],
    cols: ['load_location'],
    vals: ['net_weight'],
    renderers: Object.assign({}, TableRenderers, PlotlyRenderers)
                
  }
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const tripsSlice = createSlice({
  name: "trips",
  initialState: initialTripsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
        state.loadingMessage = "Loading...";
        state.entities = [];
        state.totalCount = 0;
        state.error = null;
      } else {
        state.actionsLoading = true;
      }
    },
    // getTripById
    tripFetched: (state, action) => {
      state.actionsLoading = false;
      state.tripForEdit = action.payload.tripForEdit;
      state.error = null;
    },
    settingsChanged: (state, action) => {
      if(action.payload.datesChanged) {
        state.entities = [];
        state.totalCount = 0;
      }
      state.settings = action.payload.settings;
    },
    pivotSettingsChanged: (state, action) => {
      state.pivotSettings = action.payload.pivotSettings;
    },
    // findTrips
    tripsFetched: (state, action) => {
      const { totalCount, entities, queryParams } = action.payload;
      state.listLoading = false;
      state.error = null;
      console.log("total", entities.length, "page size", queryParams.pageSize, "page num", queryParams.pageNumber, "slicing ", queryParams.pageSize * (queryParams.pageNumber -1), "to", queryParams.pageSize * queryParams.pageNumber)
      state.entities = entities; //.slice(queryParams.pageSize * (queryParams.pageNumber -1), queryParams.pageSize * queryParams.pageNumber);
      state.totalCount = totalCount;
    },
    tripsFetchProgressed: (state, action) => {
      const { totalCount, loadingMessage } = action.payload;
      state.totalCount = totalCount;
      state.loadingMessage = loadingMessage;
    },
    tripUpdated: (state, action) => {
      const { trip } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = state.entities.map(e => e.trip_id === trip.trip_id ? trip : e); //.slice(queryParams.pageSize * (queryParams.pageNumber -1), queryParams.pageSize * queryParams.pageNumber);
      //state.totalCount = state.totalCount;
    },
    // findTrips
    drumRotationsFetched: (state, action) => {
      const { totalCount, entities, queryParams } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.drumRotationsEntities = entities; //.slice(queryParams.pageSize * (queryParams.pageNumber -1), queryParams.pageSize * queryParams.pageNumber);
      state.drumRotationsTotalCount = totalCount;
    },
    // tripsUpdateState
    tripsStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
